import React, { useEffect, useState } from "react";

// 2️⃣  UI library (NextUI) – keep this grouped
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  Select,
  SelectItem,
  Switch,
  Textarea,
  useDisclosure,
} from "@nextui-org/react";

// 3️⃣  Third-party helpers / icons / form libs
import axios from "axios";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { IoAddSharp } from "react-icons/io5";
import { IoMdAdd, IoMdClose } from "react-icons/io";
import { GoDash } from "react-icons/go";
import { refreshIfNeeded } from "../../store/actions/refreshIfNeeded";
import { removeAuth } from "../../store/slices/authSlice";
import { toast } from "react-toastify";

// 4️⃣  React-Redux & Router
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Resizer from "react-image-file-resizer";

// 5️⃣  Project utilities & data
import { inputStyle, inputWrapperStyle } from "../../data/inputStyleData";
import { handleTypeNumber, imageResizer } from "../../utils";

// 6️⃣  Redux slices (data fetchers)
import {
  getAllSalesRep,
  getAllPartType,
} from "../../store/slices/customerSlice";
import { getWarranty } from "../../store/slices/adminSlice";

// 7️⃣  Layouts & local components
import QuoteLayout from "../../layouts/QuoteLayout";
import AddAssignee from "./AddAssignee";
import RequestDetails from "./RequestDetails";

// 8️⃣  (Optional) Chat component route export
import { ChatBox } from "../../routes";

const QuoteGen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [users, setUsers] = useState();
  const [images, setImages] = useState([]);
  const [customFields, setCustomFields] = useState([]);
  const [AddFields, setAddFields] = useState([]);
  const [options, setoptions] = useState([]);
  const [removeVisible, setRemoveVisible] = useState(false);
  const [show, setShow] = useState(false);
  const { id } = useParams();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const MAX_IMAGES = 5;

  const authHeaders = () => ({
    headers: {
      authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });
  const ensureAuth = async () => {
    // refreshIfNeeded thunk ko await karo → naya token localStorage me set hoga
    await dispatch(refreshIfNeeded());
    return authHeaders(); // hamesha latest token se header banao
  };

  const {
    register,
    control,
    handleSubmit,
    setValue,
    getValues,
    watch,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      options: [
        {
          part_type: "",
          part_price: 0,
          quantity: 0,
          freight_price: 0,
          warranty: "",
          notes: "",
          warrantyOption: "",
          warranty_price: 0,
          applyTax: false,
        },
      ],
    },
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "options",
  });
  const toggleShow = () => {
    setShow((prevState) => !prevState);
  };

  const warrantyOption = watch("warranty_option");
  const { warranty } = useSelector((state) => state.admin);

  const { reps, part_type } = useSelector((state) => state.customer);
  const {
    isOpen: addAssignee,
    onOpen: sumAssignee,
    onClose: closeAssignee,
  } = useDisclosure();
  const customer_details = JSON.parse(localStorage.getItem("customer_request"));

  // const uploadImage = async (e) => {
  //   const next = [...images];

  //   for (const file of Array.from(e.target.files)) {
  //     try {
  //       const resizedFile = await new Promise((resolve) => {
  //         Resizer.imageFileResizer(
  //           file,
  //           800,
  //           800,
  //           "JPEG",
  //           80,
  //           0, // width, height, format, quality, rotate
  //           (blob) => resolve(blob), // blob is actually a File
  //           "file" // <-- यही magic flag
  //         );
  //       });
  //       next.push(resizedFile);
  //     } catch (err) {
  //       toast.error("Image resize failed");
  //     }
  //   }
  //   setImages(next);
  // };

  const uploadImage = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;

    const available = MAX_IMAGES - images.length;
    if (available <= 0) {
      toast.info(`Maximum ${MAX_IMAGES} images allowed`);
      e.target.value = ""; // same files reselect karne ke liye reset
      return;
    }
    const toProcess = files.slice(0, available); // sirf jitni space bachi utni lo
    const resized = [];
    for (const file of toProcess) {
      try {
        const resizedFile = await new Promise((resolve, reject) => {
          Resizer.imageFileResizer(
            file,
            800,
            800,
            "JPEG",
            80,
            0,
            (blob) =>
              blob instanceof Blob
                ? resolve(blob)
                : reject(new Error("Resize failed")),
            "file"
          );
        });
        resized.push(resizedFile);
      } catch {
        toast.error("Image resize failed");
      }
    }
    setImages((prev) => [...prev, ...resized]);

    if (files.length > available) {
      toast.warn(
        `Only ${available} more image(s) allowed (max ${MAX_IMAGES}).`
      );
    }
    e.target.value = ""; // input clear
  };
  const addCustomField = () => {
    setRemoveVisible(true);
    setCustomFields([
      ...customFields,
      {
        custom_part_type: "",
        part_price: 0,
        quantity: 0,
        freight_price: 0,
        warranty: "",
        warrantyOption: "",
        warranty_price: 0,
        notes: "",
        applyTax: false,
      },
    ]);
  };

  const removeCustomField = (indexToRemove) => {
    let updatedCustomOptions = getValues("customOptions").filter(
      (_, index) => index !== indexToRemove
    );

    setCustomFields(updatedCustomOptions);
    setValue("customOptions", updatedCustomOptions, { shouldValidate: true });

    // console.log("Updated Custom Options: ", updatedCustomOptions);
  };

  // useEffect(() => console.log("useeffect data", customFields), [customFields]);
  const onSubmit = async (data) => {
    if (images.length > MAX_IMAGES) {
      toast.error(`Maximum ${MAX_IMAGES} images allowed`);
      return;
    }
    // console.log("Condition DATA", data);
    setIsSubmitting(true);
    let date = `${watch("shipping_date")}T05:30:00`;

    let warranty = Number(data.warranty);

    // data.options = data.options || [];
    // data.options = [...(data.options || []), ...(data.customOptions || [])];

    // data.customOptions?.forEach((option) => {
    //   data.options.push(option);
    // });

    const mergedOptions = [
      ...(data.options || []),
      ...(data.customOptions || []),
    ];

    const normalizeOption = (opt) => {
      const o = { ...opt };
      // warrantyOption -> warranty_option
      if (o.warrantyOption != null && o.warranty_option == null) {
        o.warranty_option = o.warrantyOption;
      }
      delete o.warrantyOption;
      // number guards
      o.applyTax = !!o.applyTax;
      o.warranty_price = isNaN(o.warranty_price)
        ? 0
        : Number(o.warranty_price || 0);
      o.part_price = isNaN(o.part_price) ? 0 : Number(o.part_price || 0);
      o.quantity = isNaN(o.quantity) ? 1 : Number(o.quantity || 1);
      o.freight_price = isNaN(o.freight_price)
        ? 0
        : Number(o.freight_price || 0);
      o.warranty = isNaN(o.warranty) ? 0 : Number(o.warranty || 0);
      return o;
    };
    const updatedOptions = mergedOptions
      .map(normalizeOption)
      .filter((o) => (o.part_type || o.custom_part_type) && o.part_price > 0);

    data.applyTax = data.applyTax || false;
    // isNaN(data.freight_price) && delete data.freight_price;
    data.freight_price = isNaN(data.freight_price) ? 0 : data.freight_price;
    delete data.customOptions;
    delete data.part_type;

    // let final_data = {
    //   ...data,
    //   warranty,
    //   warranty_price: data.warranty_price || 0,
    //   shipping_date: date,
    //   images,
    //   options: updatedOptions,
    // };

    const finalData = new FormData();

    finalData.append("warranty", warranty);
    finalData.append("warranty_price", data.warranty_price || 0);
    finalData.append("shipping_date", date);
    finalData.append("applyTax", String(!!data.applyTax));
    /* primitive fields */
    [
      "part_price",
      "freight_price",
      "interchange_number",
      "reference_id",
      "sales_repId",
      "notes",
    ].forEach((k) => data[k] != null && finalData.append(k, data[k]));

    /* images[] */
    images.forEach((file) => finalData.append("images[]", file));

    const ALLOWED = new Set([
      "part_type",
      "custom_part_type",
      "part_price",
      "quantity",
      "freight_price",
      "warranty",
      "warranty_option",
      "warranty_price",
      "notes",
      "applyTax",
    ]);
    /* options[i][field]  →  the structure your backend already expects */
    updatedOptions.forEach((opt, i) => {
      Object.entries(opt).forEach(([k, v]) => {
        const key = k; // already normalized above
        if (!ALLOWED.has(key)) return;
        if (v === "" || v === null || typeof v === "undefined") return;
        finalData.append(`options[${i}][${key}]`, String(v));
      });
    });

    try {
      // console.log("customer_details........", customer_details)
      const headers = await ensureAuth(); // ✅ refresh → latest token
      const res = await axios.post(
        `${process.env.REACT_APP_SERVER_URL_V2}/quotes/createquote/${customer_details.id}`,
        finalData,
        headers
      );

      toast.success(`${res.data?.message} ⭐`);
      setTimeout(() => {
        navigate("/quotes");
      }, 2500);
    } catch (error) {
      let err =
        error.response?.data?.message || "Please create stripe account first";
      toast.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const today = new Date().toISOString().split("T")[0];

  function recieptList() {
    let freight_price = parseFloat(watch("freight_price")) || 0;
    let part_price = parseFloat(watch("part_price")) || 0;
    let warranty_price = parseFloat(watch("warranty_price")) || 0;

    const recieptObj = {};
    const quantity = customer_details?.quantity || 1;
    const totalPrice = freight_price + part_price * quantity + warranty_price;
    const applyTax = watch("applyTax");
    const taxRate = 10 / 100;

    if (applyTax && taxRate > 0) {
      const taxableAmount = totalPrice - warranty_price;
      recieptObj.totalTax = Number((taxableAmount * taxRate).toFixed(2));

      recieptObj.totalPrice = Number(
        (totalPrice + recieptObj.totalTax).toFixed(2)
      );
    } else {
      recieptObj.totalTax = 0;
      recieptObj.totalPrice = Number(totalPrice);
    }

    // Assign values
    recieptObj.freightPrice = Number(freight_price.toFixed(2));
    recieptObj.partPrice = Number(part_price.toFixed(2));
    recieptObj.warrantyPrice = Number(warranty_price.toFixed(2));

    // console.log("Final Receipt Object:", recieptObj);
    return recieptObj;
  }

  const bill = recieptList();

  useEffect(() => {
    dispatch(getAllSalesRep());
    dispatch(getAllPartType());
    dispatch(getWarranty());
  }, []);

  useEffect(() => {
    reset({
      shipping_address: users?.address_line_1,
    });
  }, [users]);

  return (
    <div className="md:px-7 md:py-3">
      <RequestDetails />
      <div>
        <div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <QuoteLayout heading={"Price Details"}>
              <div className="mb-2 md:mb-0">
                <Input
                  type="number"
                  label="Part Price $"
                  placeholder="Price $"
                  variant="bordered"
                  labelPlacement={"outside"}
                  description={""}
                  onWheel={(e) => e.target.blur()}
                  onKeyDown={handleTypeNumber}
                  isRequired={true}
                  {...register("part_price", {
                    required: true,
                    valueAsNumber: true,
                  })}
                />
                {errors.part_price && (
                  <p className="text-xs text-red-500 pl-2 pt-2">
                    Enter part price
                  </p>
                )}
              </div>
              <div className="mb-2 md:mb-0 border-2 border-white">
                <Input
                  type="number"
                  label="Freight Price $"
                  placeholder="Freight Price $"
                  variant="bordered"
                  labelPlacement="outside"
                  onWheel={(e) => e.target.blur()}
                  onKeyDown={handleTypeNumber}
                  {...register("freight_price", {
                    valueAsNumber: true,
                    setValueAs: (v) =>
                      v === "" || v === null || isNaN(v) ? 0 : v,
                  })}
                />
              </div>

              <Controller
                name="applyTax"
                control={control}
                render={({ field }) => (
                  <Switch
                    size="sm"
                    checked={field.value}
                    onChange={field.onChange}
                  >
                    Price Exclusive Of Tax
                  </Switch>
                )}
              />
            </QuoteLayout>
            <QuoteLayout heading={"Shipping and Warranty"}>
              <div className="mb-2 md:mb-0 border-2 border-white">
                <Select
                  variant="bordered"
                  labelPlacement={"outside"}
                  label="Select Sales Representative"
                  placeholder="Select Sales Rep"
                  className="w-full text-black"
                  isRequired={true}
                  {...register("sales_repId", {
                    required: "Sales Representative is required",
                    valueAsNumber: true,
                  })}
                >
                  <SelectItem key="" onClick={() => sumAssignee()}>
                    <div className="flex gap-2 items-center">
                      <IoAddSharp style={{ fontSize: "0.9rem" }} />
                      <p>Add Sales Rep</p>
                    </div>
                  </SelectItem>
                  {reps.map((rep) => (
                    <SelectItem key={rep.id} value={rep.SalesRepName}>
                      {rep.SalesRepName}
                    </SelectItem>
                  ))}
                </Select>
                {errors.sales_repId && (
                  <p className="text-xs text-red-500 pl-2 pt-2">
                    {errors.sales_repId.message}
                  </p>
                )}
              </div>

              <div className="mb-2 md:mb-0 border-2 border-white">
                <Input
                  type="date"
                  label="Date you can send the part"
                  variant="bordered"
                  labelPlacement={"outside"}
                  placeholder="Enter date"
                  description={""}
                  className="w-full text-black"
                  min={today}
                  isRequired={true}
                  {...register("shipping_date", { required: true })}
                />
                {errors.shipping_date && (
                  <p className="text-xs text-red-500 pl-2 pt-2">
                    Enter Shipping Date
                  </p>
                )}
              </div>

              <div className="mb-2 md:mb-0 border-2 border-white">
                <Input
                  type="file"
                  label="Upload images ( Max 5 images )"
                  classNames={{
                    input: inputStyle,
                    inputWrapper: inputWrapperStyle,
                  }}
                  multiple
                  accept="image/png, image/jpeg"
                  labelPlacement={"outside"}
                  placeholder="Choose images"
                  description={""}
                  {...register("images")}
                  onChange={(e) => uploadImage(e)}
                  isDisabled={images.length >= MAX_IMAGES}
                />{" "}
                <div className="text-sm mt-2">
                  <span className="text-gray-600">
                    {images.length}/{MAX_IMAGES} images uploaded
                  </span>
                  {images.length >= MAX_IMAGES && (
                    <span className="text-red-500 ml-2">Max reached</span>
                  )}
                </div>
              </div>

              <div className="mb-2 md:mb-0 border-2 border-white">
                <Select
                  labelPlacement={"outside"}
                  variant="bordered"
                  className="w-full"
                  label="Warranty Duration"
                  id="duration"
                  placeholder="Warranty Duration"
                  isRequired={true}
                  {...register("warranty", {
                    required: true,
                    valueAsNumber: true,
                  })}
                >
                  {warranty?.map((item, index) => {
                    const val = item.duration + " " + item.unit;

                    return (
                      item.duration !== 0 && (
                        <SelectItem key={item.id} value={item.id}>
                          {val}
                        </SelectItem>
                      )
                    );
                  })}
                </Select>
                {errors.warranty && (
                  <p className="text-xs text-red-500 pl-2 pt-2">
                    Enter warranty duration
                  </p>
                )}
              </div>

              <div className="mb-2 md:mb-0 border-2 border-white">
                <Input
                  type="text"
                  label="Interchange Number"
                  placeholder="Enter Interchange Number"
                  variant="bordered"
                  labelPlacement={"outside"}
                  description={""}
                  {...register("interchange_number")}
                />
              </div>
              {/* <div className="mb-2 md:mb-0">
                <Input
                  type="text"
                  label="Reference Number"
                  placeholder="Enter Reference Number"
                  variant="bordered"
                  labelPlacement="outside"
                  isRequired={true}
                  {...register("reference_id", {
                    setValueAs: (v) => String(v),
                    // minLength: {
                    //   value: 8,
                    //   message: "Reference number must be at least 8 digits long",
                    // },
                    pattern: {
                      value: /^[0-9]+$/,
                      message: "Reference number must contain only numbers",
                    },
                  })}
                />
                {errors.reference_id && (
                  <>
                    <p className="text-red-500 text-sm">{errors.reference_id.message}</p>
                    {toast.error(errors.reference_id.message)}
                  </>
                )}
              </div> */}
              <div className="mb-2 md:mb-0 border-2 border-white">
                <Input
                  type="text"
                  label="Reference Number"
                  placeholder="Enter Reference Number"
                  variant="bordered"
                  labelPlacement="outside"
                  isRequired={true}
                  {...register("reference_id", {
                    setValueAs: (v) => String(v),
                    pattern: {
                      value: /^[a-zA-Z0-9]+$/,
                      message:
                        "Reference number must contain only letters and numbers",
                    },
                  })}
                />
                {errors.reference_id && (
                  <>
                    <p className="text-red-500 text-sm">
                      {errors.reference_id.message}
                    </p>
                    {toast.error(errors.reference_id.message)}
                  </>
                )}
              </div>
            </QuoteLayout>
            <QuoteLayout heading={"Add Your Own Warranty Option"}>
              <div className="mb-2 md:mb-0">
                <Input
                  type="text"
                  label="Warranty Option"
                  placeholder="Warranty Option"
                  variant="bordered"
                  labelPlacement={"outside"}
                  description={""}
                  {...register("warranty_option")}
                />
              </div>

              <div className="mb-2 md:mb-0 border-2 border-white">
                <Input
                  type="number"
                  label="Warranty Price $"
                  placeholder="Warranty Price $"
                  variant="bordered"
                  labelPlacement={"outside"}
                  description={""}
                  onKeyDown={handleTypeNumber}
                  onWheel={(e) => e.target.blur()}
                  {...register("warranty_price", {
                    valueAsNumber: true,
                  })}
                />
              </div>
            </QuoteLayout>

            <div className="flex mt-2 pb-5 pt-5 cursor-pointer ">
              <IoMdAdd className="m-1 ml-0" onClick={toggleShow} />
              <h1
                className="text-base sm:text-xl font-semibold"
                onClick={toggleShow}
              >
                Other Options
              </h1>
            </div>
            {show && (
              <div className="col-span-2 border-b-1 border-gray-100 pb-7">
                {fields?.map((field, index) => (
                  <div className="mt-4">
                    <div className="md:grid md:grid-cols-2 gap-4">
                      <Select
                        className="mb-2 "
                        variant="bordered"
                        label="Part Type"
                        labelPlacement={"outside"}
                        placeholder="Select Part Type"
                        name={`part_type`}
                        {...register(`options[${index}].part_type`, {
                          required: false,
                        })}
                      >
                        {part_type.map((e) => (
                          <SelectItem key={e.id} value={e.id}>
                            {e.name}
                          </SelectItem>
                        ))}
                      </Select>
                      <div className="md:grid md:grid-cols-2 gap-2">
                        <Input
                          type="number"
                          label="Part Price"
                          variant="bordered"
                          className="mb-2 "
                          labelPlacement={"outside"}
                          name={`part_price`}
                          onWheel={(e) => e.target.blur()}
                          onKeyDown={handleTypeNumber}
                          isRequired={true}
                          {...register(`options[${index}].part_price`, {
                            required: false,
                            valueAsNumber: true,
                          })}
                          placeholder="Part Price"
                        />
                        <Input
                          type="number"
                          label="Quantity"
                          variant="bordered"
                          className="mb-2 "
                          labelPlacement={"outside"}
                          name={`quantity`}
                          onWheel={(e) => e.target.blur()}
                          {...register(`options[${index}].quantity`, {
                            required: false,
                            valueAsNumber: true,
                          })}
                          placeholder="Quantity"
                        />
                      </div>
                    </div>
                    <div className="md:grid md:grid-cols-2 gap-4 mb-2 ">
                      <Input
                        type="number"
                        label="Freight Price"
                        variant="bordered"
                        className="mb-2 "
                        labelPlacement={"outside"}
                        name={`freight_price`}
                        onWheel={(e) => e.target.blur()}
                        {...register(`options[${index}].freight_price`, {
                          required: false,
                          valueAsNumber: true,
                        })}
                        placeholder="Freight Price"
                      />
                      <Select
                        labelPlacement={"outside"}
                        variant="bordered"
                        className="w-full"
                        label="Warranty Duration"
                        id="duration"
                        placeholder="warranty duration"
                        isRequired={true}
                        {...register(`options[${index}].warranty`, {
                          valueAsNumber: true,
                        })}
                      >
                        {warranty?.map((item, index) => {
                          const val = item.duration + " " + item.unit;
                          return (
                            <SelectItem key={item.id} value={item.id}>
                              {val}
                            </SelectItem>
                          );
                        })}
                      </Select>
                    </div>
                    <div className="md:grid md:grid-cols-2 gap-4 mb-2">
                      <Input
                        type="text"
                        label="Warranty Option"
                        variant="bordered"
                        className="mb-2 "
                        labelPlacement={"outside"}
                        name={`warranty_option`}
                        {...register(`options[${index}].warranty_option`, {
                          required: false,
                        })}
                        placeholder="Warranty Option"
                      />
                      <Input
                        type="number"
                        label="Warranty Price"
                        variant="bordered"
                        className="mb-2 "
                        labelPlacement={"outside"}
                        name={`warranty_price`}
                        onWheel={(e) => e.target.blur()}
                        {...register(`options[${index}].warranty_price`, {
                          required: false,
                          valueAsNumber: true,
                        })}
                        placeholder="Warranty Price $"
                      />
                    </div>
                    <div className="md:grid md:grid-cols-2 gap-4 mb-2">
                      <Textarea
                        key={"bordered"}
                        variant={"bordered"}
                        label="Notes"
                        labelPlacement="outside"
                        placeholder="Include Details Such As Mileage, Colour, And Condition Of The Vehicle Parts....."
                        className="col-span-2 "
                        {...register(`options[${index}].notes`, {
                          required: false,
                        })}
                      />
                    </div>
                    <Controller
                      name={`options[${index}].applyTax`}
                      control={control}
                      defaultValue={false}
                      render={({ field }) => {
                        return (
                          <Switch
                            size="sm"
                            checked={field.value}
                            onChange={field.onChange}
                          >
                            Price Exclusive Of Tax
                          </Switch>
                        );
                      }}
                    />
                    <div className="flex justify-end items-center">
                      <button
                        type="button"
                        className="flex items-center space-x-1"
                        onClick={() => remove(index)}
                      >
                        <IoMdClose />
                        <span className="text-[12px]">Remove Part Type</span>
                      </button>
                    </div>
                  </div>
                ))}

                {customFields.map((options, index) => (
                  <>
                    <div className="mt-4 p-4">
                      {/* Row 1: Custom Part Type / Custom Price / Quantity */}
                      <div className="grid md:grid-cols-3 gap-4 mb-4">
                        <Input
                          type="text"
                          label="Custom Part Type"
                          variant="bordered"
                          labelPlacement="outside"
                          {...register(
                            `customOptions[${index}].custom_part_type`,
                            {
                              required: false,
                            }
                          )}
                          placeholder="Custom Part Type"
                        />
                        <Input
                          type="number"
                          label="Custom Price"
                          variant="bordered"
                          labelPlacement="outside"
                          onWheel={(e) => e.target.blur()}
                          {...register(`customOptions[${index}].part_price`, {
                            required: false,
                            valueAsNumber: true,
                          })}
                          placeholder="Custom Part Price"
                        />
                        <Input
                          type="number"
                          label="Quantity"
                          variant="bordered"
                          labelPlacement="outside"
                          onWheel={(e) => e.target.blur()}
                          {...register(`customOptions[${index}].quantity`, {
                            required: false,
                            valueAsNumber: true,
                          })}
                          placeholder="Quantity"
                        />
                      </div>

                      {/* Row 2: Freight Price / Warranty Duration */}
                      <div className="grid md:grid-cols-2 gap-4 mb-4">
                        <Input
                          type="number"
                          label="Freight Price"
                          variant="bordered"
                          labelPlacement="outside"
                          onWheel={(e) => e.target.blur()}
                          {...register(
                            `customOptions[${index}].freight_price`,
                            {
                              required: false,
                              valueAsNumber: true,
                            }
                          )}
                          placeholder="Freight Price"
                        />
                        <Select
                          labelPlacement="outside"
                          variant="bordered"
                          label="Warranty Duration"
                          placeholder="Warranty duration"
                          isRequired={true}
                          {...register(`customOptions[${index}].warranty`, {
                            valueAsNumber: true,
                          })}
                        >
                          {warranty?.map((item) => {
                            const val = item.duration + " " + item.unit;
                            return (
                              <SelectItem key={item.id} value={item.id}>
                                {val}
                              </SelectItem>
                            );
                          })}
                        </Select>
                      </div>

                      {/* Row 3: Warranty Option / Warranty Price */}
                      <div className="grid md:grid-cols-2 gap-4 mb-4">
                        <Input
                          type="text"
                          label="Warranty Option"
                          variant="bordered"
                          labelPlacement="outside"
                          {...register(
                            `customOptions[${index}].warranty_option`,
                            {
                              required: false,
                            }
                          )}
                          placeholder="Warranty Option"
                        />
                        <Input
                          type="number"
                          label="Warranty Price"
                          variant="bordered"
                          labelPlacement="outside"
                          onWheel={(e) => e.target.blur()}
                          {...register(
                            `customOptions[${index}].warranty_price`,
                            {
                              required: false,
                              valueAsNumber: true,
                            }
                          )}
                          placeholder="Warranty Price $"
                        />
                      </div>

                      {/* Row 4: Notes full width */}
                      <div className="mb-4">
                        <Textarea
                          variant="bordered"
                          label="Notes"
                          labelPlacement="outside"
                          placeholder="Include details such as mileage, colour, and condition of the vehicle parts....."
                          {...register(`customOptions[${index}].notes`, {
                            required: false,
                          })}
                        />
                      </div>

                      {/* Row 5: Tax Switch */}
                      <div className="mb-2">
                        <Controller
                          name={`customOptions[${index}].applyTax`}
                          control={control}
                          render={({ field }) => (
                            <Switch
                              size="sm"
                              checked={field.value}
                              onChange={field.onChange}
                            >
                              Price Exclusive Of Tax
                            </Switch>
                          )}
                        />
                      </div>
                    </div>

                    <div className="flex justify-end items-center">
                      <button
                        onClick={() => removeCustomField(index)}
                        className="flex items-center space-x-1"
                        type="button"
                      >
                        <span>
                          <IoMdClose />
                        </span>
                        <span className="text-[12px]">Remove Custom Type</span>
                      </button>
                    </div>
                  </>
                ))}

                <div className="flex justify-between w-full ">
                  <div className="w-full">
                    <div className="flex justify-between w-full">
                      <button
                        className="flex items-center gap-2 text-small "
                        type="button"
                        onClick={addCustomField}
                      >
                        <IoMdAdd />{" "}
                        <p className="text-md sm:text-xs">Add Custom Part</p>
                      </button>
                    </div>

                    <div className="flex justify-between items-center mt-2">
                      <button
                        type="button"
                        className="flex items-center gap-2 text-small"
                        onClick={() =>
                          append({
                            part_type: "",
                            part_price: 0,
                            quantity: 0,
                            freight_price: 0,
                            warranty: "",
                            warrantyOption: "",
                            warranty_price: 0,
                            applyTax: false,
                          })
                        }
                      >
                        <IoMdAdd /> <p className="sm:text-xs">Add Part</p>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <QuoteLayout heading={"Add Note"}>
              <div className="col-span-2 mb-2 md:mb-0">
                <Textarea
                  key={"bordered"}
                  variant={"bordered"}
                  label="Notes"
                  labelPlacement="outside"
                  placeholder="Include details such as mileage, colour, and condition of the vehicle parts....."
                  className="col-span-2 "
                  {...register("notes", { required: false })}
                />
              </div>
            </QuoteLayout>

            <div className="pt-5 pb-7">
              <div className="sm:grid grid-cols-2">
                <div>
                  <p className="text-base sm:text-xl font-semibold">
                    Transaction:
                  </p>
                </div>
                <div>
                  <div className="mx-2 sm:mx-6 border-b-1 border-gray-300 pb-1 grid grid-cols-2">
                    <div className="text-left leading-7 font-semibold text-xs sm:text-lg">
                      <p>
                        {/* {console.log("Customer Details:", customer_details)} */}
                        Parts Cost{" "}
                        <span className="text-xs">
                          ({customer_details?.quantity} Qnty)
                        </span>
                      </p>

                      <p>
                        {/* Shipping Cost <span className="text-xs">(ex GST)</span> */}
                        Freight Price <span className="text-xs"></span>
                      </p>
                      <p>
                        Warranty <span className="text-xs">(ex GST) </span>
                      </p>
                      <p>Tax Total</p>
                    </div>
                    <div className="text-right leading-7 text-xs sm:text-lg">
                      <p>
                        {/* {console.log("Bill Data:", bill)} */}

                        {bill.partPrice > 0
                          ? "$" +
                            (
                              bill.partPrice * customer_details?.quantity
                            ).toFixed(2)
                          : "$00"}
                      </p>
                      {/* <p>
                        {bill.freightPrice > 0
                          ? `${bill.freightPrice.toFixed(2)}`
                          : "$00.00"}
                      </p> */}
                      <p>
                        {bill.freightPrice > 0
                          ? `$${bill.freightPrice.toFixed(2)}`
                          : "$00.00"}
                      </p>
                      <p>
                        {bill.warrantyPrice > 0
                          ? `$${bill.warrantyPrice.toFixed(2)}`
                          : "$00.00"}
                      </p>
                      <p>
                        {bill.totalTax === 0
                          ? "$00.00"
                          : `$${bill.totalTax.toFixed(2)}`}
                      </p>
                    </div>
                  </div>
                  <div className="flex justify-between mx-2 sm:mx-6 py-2 text-sm sm:text-lg font-semibold">
                    <div>
                      <p>Grand Total</p>
                    </div>
                    <div>
                      <p>{`$${(bill.totalPrice ?? 0).toFixed(2)}`}</p>
                    </div>
                    {/* {console.log("Grand Total Price:", bill.totalPrice)} */}
                  </div>
                  <div className="flex justify-end">
                    {/* <button className="mobile-only:w-full sm:mx-6 bg-lightBlue text-white rounded-lg py-2 px-4 mt-2">
                      Create Quote
                    </button> */}
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="mobile-only:w-full sm:mx-6 bg-lightBlue text-white rounded-lg py-2 px-4 mt-2"
                    >
                      {isSubmitting ? "Creating…" : "Create Quote"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <AddAssignee
            addAssignee={addAssignee}
            closeAssignee={closeAssignee}
          />
        </div>
      </div>
      {/* <div className="mt-5">
        <ChatBox quoteId={id} />
        {console.log("id----->>>>>>>>>>",id)}
      </div> */}
    </div>
  );
};

export default QuoteGen;
